import React from 'react';
import { 
    Card,
    Image,
    Text,
    Group,
    Badge,
    createStyles,
    Center,
    Button,
    ActionIcon
} from '@mantine/core';
import {
    IconGavel,
    IconHourglass,
    IconHeartPlus,
    IconHeart,
    IconEye,
    IconBell
} from '@tabler/icons';
import { ResponsiveCarouselCard } from './ResponsiveCarouselCard';
const useStyles = createStyles((theme) => ({
    cardContain: {
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,    
        width: '95%',
        margin: '0 auto',
        maxWidth: '800px',
    },

    imageSection: {
        padding: theme.spacing.md,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        /*borderBottom: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
        }`,*/
    },
    
    label: {
        marginBottom: theme.spacing.xs,
        lineHeight: 1,
        fontWeight: 700,
        fontSize: theme.fontSizes.xs,
        letterSpacing: -0.25,
        textTransform: 'uppercase',
    },

    section: {
        padding: theme.spacing.md,
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
        }`,
    },
    subSection: {
        borderBottom: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
        }`,
    },

    icon: {
        marginRight: 5,
        color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[5],
    },
}));

//<Image src="https://i.imgur.com/ZL52Q2D.png" alt="Tesla Model S" />
export function CarComponent() {
  const { classes } = useStyles();

    return (
        <Card withBorder radius="md" className={classes.cardContain}>
            <Card.Section className={classes.imageSection}>
                <ResponsiveCarouselCard />
            </Card.Section>
            
            <Card.Section className={classes.section} mt="md">
                <Text size="lg" weight={700}>
                2015 Pagani Huayra Mint Condition Barley Used
                </Text>
                <br/>
                <Text size="md" color="dimmed" className={classes.label}>
                Pittsburgh, Pennsylvania
                </Text>
            </Card.Section>

            <Card.Section className={classes.section,classes.subSection}>
                <Group position="apart">
                    <div>
                        <Text size="lg" weight={700} sx={{ lineHeight: 1 }}>
                        Bid $95,000
                        </Text>
                    </div>
                    <Text size="lg" weight={700}>
                    8 Days
                    </Text>
                </Group>
            </Card.Section>

            <Card.Section className={classes.section}>
                <Group position="center">
                    <div>
                        <ActionIcon variant="transparent" size="lg">
                            <IconBell color={"black"} size={55} stroke={2.0}/>
                        </ActionIcon>
                    </div>
                </Group>
            </Card.Section>
        </Card>
    );
}
